import { PostHv } from './helpers';
import { getEnv } from '@/utils/env';

export type AdminAuthRequest = {
  auth_code: string;

  oauth2?: boolean;
  channel?: number;
  user_pool_client_id?: string;
  domain?: string;
};

export function SSOAdminAuth(payload: AdminAuthRequest): Promise<{ token?: string; reason?: string }> {
  const redirectURL = new URL(window.location.href);

  if (redirectURL.searchParams.has('code')) {
    redirectURL.searchParams.delete('code');
  }

  if (redirectURL.searchParams.has('state')) {
    redirectURL.searchParams.delete('state');
  }

  return PostHv({
    host: getEnv().VITE_HOSTS_AUTHORIZATION,
    url: `/auth/admin/sso`,
    body: {
      ...payload,
      redirect_uri: redirectURL.href,
    },
  });
}
